import {gmapApi} from "vue2-google-maps";
import Marker from "../structures/Marker";
import Polygon from "../structures/Polygon";

export const MapUtilitiesMixin = {
    data() {
        return {
            moved: false,
            moveListener: null,
        }
    },
    computed: {
        google: gmapApi,
        visibleMarkers() {
            return this.markers;
        },
        markers() {
            let markers = this.data.filter((location) => {
                return typeof location.address !== 'undefined';
            });

            return markers.map((location) => {
                location = JSON.parse(JSON.stringify(location));

                return new Marker(this.$refs.map, location);
            });
        },
        polygons() {
            let polygons = this.data.filter((location) => {
                return typeof location.polygons !== 'undefined';
            })

            return polygons.map((location) => {
                location = JSON.parse(JSON.stringify(location));

                return new Polygon(location);
            });
        }
    },
    methods: {
        fitToMarkers() {
            return this.$refs.map.$mapPromise.then((map) => {
                let bounds = new this.google.maps.LatLngBounds();

                this.visibleMarkers.forEach((marker) => {
                    let position = marker.getPosition();
                    if (position && position.lat && position.lng) {
                        bounds.extend(new this.google.maps.LatLng(position));
                    }
                });

                this.polygons.forEach((polygon) => {
                    polygon.getShapes().forEach((shape) => {
                        shape.forEach((coordinate) => {
                            bounds.extend(new this.google.maps.LatLng(coordinate));
                        });
                    });
                });

                this.stopListeningForMoves();
                map.fitBounds(bounds);

                let fitListener = map.addListener('bounds_changed', () => {
                    this.listenForMoves(map);
                    fitListener.remove();
                    if ( map.getZoom() > 11 ) map.setZoom(11);
                });
            });
        },
        stopListeningForMoves() {
            if (this.moveListener) {
                this.moveListener.remove();
            }
        },
        listenForMoves(map) {
            this.moveListener = map.addListener('bounds_changed', () => {
                this.moved = true;
            });
        },
        resetMap() {
            this.fitToMarkers();
            this.moved = false;
        },
    },
}

export default MapUtilitiesMixin;
